import React from "react";
import { Link } from "react-router-dom";
import Stars from "./Stars";

const CasinoCard = ({ casino, delay = 0 }) => {
  return (
    <div
      className="cp-fade-up cp-card group rounded-2xl border p-4 transition-all duration-300 sm:p-5"
      style={{
        borderColor: "var(--cp-border)",
        background: "var(--cp-card)",
        animationDelay: `${delay}ms`,
      }}
    >
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center">
        {/* Rank + logo + name */}
        <div className="flex items-center gap-4 lg:w-[300px]">
          <span
            className="w-6 flex-shrink-0 text-center text-lg font-bold"
            style={{ color: "var(--cp-muted)" }}
          >
            {casino.rank}
          </span>
          <div
            className="h-14 w-14 flex-shrink-0 overflow-hidden rounded-lg"
            style={{ background: "rgb(10,11,13)" }}
          >
            <img
              alt={casino.name}
              className="h-full w-full object-cover"
              loading="lazy"
              src={casino.logo}
            />
          </div>
          <div>
            <h3 className="text-base font-semibold" style={{ color: "#ffffff" }}>
              {casino.name}
            </h3>
            <div className="mt-1">
              <Stars rating={casino.rating} />
            </div>
          </div>
        </div>

        {/* Offer */}
        <div
          className="flex-1 rounded-lg border px-4 py-3"
          style={{
            borderColor: "var(--cp-border)",
            background: "rgba(255,255,255,0.02)",
          }}
        >
          <p
            className="mb-1 text-[10px] font-semibold uppercase tracking-widest"
            style={{ color: "var(--cp-green)" }}
          >
            Welcome Offer
          </p>
          <p className="text-sm leading-snug" style={{ color: "var(--cp-text)" }}>
            {casino.offer}
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3 lg:w-[230px] lg:justify-end">
          <Link
            to={`/${casino.slug}`}
            className="cp-review-btn flex-1 rounded-lg border py-2.5 text-center text-sm font-semibold transition-colors lg:flex-none lg:px-5"
          >
            Review
          </Link>
          <a
            href={casino.playUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="cp-play-btn flex-1 rounded-lg py-2.5 text-center text-sm font-bold transition-all lg:flex-none lg:px-6"
          >
            Play Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default CasinoCard;
